import TemplateView from '../../../TemplateView'
import SortLink from "./SortLink";
import messageResource from "../../../messageResource";
import {UserManagementConstants} from 'constants'

export default class TableControls extends TemplateView {
    constructor({
        usersFilterComponent = null,
        wordsFilterComponent = null,
        onUserSortClick = () => {},
        onUserGroupSortClick = () => {},
        onTimeZoneSortClick = () => {},
    }) {
        super(null)

        this.params = {
            usersFilterComponent,
            wordsFilterComponent,
            onUserSortClick,
            onUserGroupSortClick,
            onTimeZoneSortClick,
        }

        this.state = {
            showUserGroups: false,
            showTimeZoneGroups: false,
            sorting: {
                order: -1,
                asc: false,
            }
        }

        this.onStateChanged(() => {
            this.userGroupSortLink.getEl().toggleClass('hidden', !this.state.showUserGroups)
            this.timeZoneSortLink.getEl().toggleClass('hidden', !this.state.showTimeZoneGroups)

            const {order, asc} = this.state.sorting
            this.userSortLink.setState({
                asc: asc,
                active: order === UserManagementConstants.USER_LIST_ORDER_BY_NAME,
            })
            this.userGroupSortLink.setState({
                asc: asc,
                active: order === UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME,
            })
            this.timeZoneSortLink.setState({
                asc: asc,
                active: order === UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME,
            })
        })
    }

    templateHtml() {
        return '<div class="userList_tableControlsContainer">' +
               '  <div class="usersFilter"></div>' +
               '  <div class="sortLinks"></div>' +
               '  <div class="wordsFilter"></div>' +
               '</div>'
    }

    afterRender() {
        if (this.params.usersFilterComponent) {
            this.params.usersFilterComponent.init(this.find('.usersFilter'))
        }
        if (this.params.wordsFilterComponent) {
            this.params.wordsFilterComponent.init(this.find('.wordsFilter'))
        }

        const sortLinksContainer = this.find('.sortLinks')
        this.userSortLink = new SortLink({
            title: messageResource.getMessage('userlist.head.name')
        }).init(sortLinksContainer)
        this.userSortLink.getEl().on('click', this.params.onUserSortClick)
        this.userGroupSortLink = new SortLink({
            title: messageResource.getMessage('userlist.usertable.group'),
            clazz: 'userGroup',
        }).init(sortLinksContainer)
        this.userGroupSortLink.getEl().on('click', this.params.onUserGroupSortClick)
        this.timeZoneSortLink = new SortLink({
            title: messageResource.getMessage('userlist.usertable.time_zone'),
            clazz: 'timeZoneGroup',
        }).init(sortLinksContainer)
        this.timeZoneSortLink.getEl().on('click', this.params.onTimeZoneSortClick)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/TableControls.js